import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  Menu,
  MenuItem,
  ListItemIcon,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import useStyles from "./HomeStyles";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import TrainIcon from "@material-ui/icons/Train";
import TrainTwoTone from "@material-ui/icons/TrainTwoTone";
import BuildIcon from "@material-ui/icons/Build";
import ReceiptIcon from "@material-ui/icons/Receipt";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import TimelineIcon from "@material-ui/icons/Timeline";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AssessmentIcon from "@material-ui/icons/Assessment";
import StorageIcon from "@material-ui/icons/Storage";

import SidenavData from "../../common/data/Navbardata";

const operationModules = [
  {
    title: "SFTO Operations",
    desc: "Manage freight rake movements, loading workflows and operational planning.",
    icon: <TrainIcon style={{ color: "#1976D2", fontSize: 28 }} />,
    path: "/railways/job/sfto/listjob",
    type: "single",
  },
  {
    title: "GPWIS Operations",
    desc: "Handle GPWIS operational jobs and transportation workflow tracking.",
    icon: <TrainTwoTone style={{ color: "#1976D2", fontSize: 28 }} />,
    path: "/railways/job/gpwis/listjob",
    type: "single",
  },
  {
    title: "Invoice Management",
    desc: "Generate and process railway invoices and reconciliation workflows.",
    icon: <ReceiptIcon style={{ color: "#1976D2", fontSize: 28 }} />,
    menuKey: "Invoice",
    type: "dropdown",
  },
  {
    title: "Maintenance Control",
    desc: "Monitor wagon maintenance and railway engineering operations.",
    icon: <BuildIcon style={{ color: "#1976D2", fontSize: 28 }} />,
    menuKey: "Maintenance",
    type: "dropdown",
  },
  {
    title: "Freight Reconciliation",
    desc: "Reconcile freight records and ensure accurate financial settlements.",
    icon: <AccountTreeIcon style={{ color: "#1976D2", fontSize: 28 }} />,
    menuKey: "SFTO Freight Reconciliation",
    type: "dropdown",
  },
  // {
  //   title: "Reports & Analytics",
  //   desc: "Access operational reports, dashboards and railway analytics.",
  //   icon: <AssessmentIcon style={{ color: "#1976D2", fontSize: 28 }} />,
  //   menuKey: "Reports",
  //   type: "dropdown",
  // },
  {
    title: "Masters Management",
    desc: "Configure railway masters, station data and operational configurations.",
    icon: <StorageIcon style={{ color: "#1976D2", fontSize: 28 }} />,
    menuKey: "Masters",
    type: "dropdown",
  },
];

export default function RailwaysHomePage() {
  const classes = useStyles();

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [activeMenu, setActiveMenu] = React.useState([]);

  const getMenuLinks = (menuText) => {
    const menu = SidenavData?.menus?.find((x) =>
      x.text?.toLowerCase().includes(menuText.toLowerCase()),
    );

    return menu?.subMenus || [];
  };

  const openMenu = (event, menuKey) => {
    const menus = getMenuLinks(menuKey);

    setActiveMenu(menus);

    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  return (
    <Box className={classes.root}>
      {/* HERO */}
      <Box className={classes.heroSection}>
        <Box className={classes.heroOverlay} />
        <Box className={classes.railwayTrack} />

        <Grid
          container
          spacing={2}
          alignItems="center"
          direction={isSmall ? "column-reverse" : "row"}
        >
          <Grid item xs={12} md={6}>
            <Box
              className={classes.heroLeft}
              style={{
                textAlign: isSmall ? "center" : "left",
                padding: isSmall ? 16 : 0,
              }}
            >
              {/* <Box
                className={classes.heroBadge}
                style={{ justifyContent: isSmall ? "center" : undefined }}
              >
                <TrainIcon style={{ fontSize: 16 }} />
                Railway Operations Management System
              </Box> */}

              <Typography
                className={classes.heroTitle}
                align={isSmall ? "center" : "left"}
                variant={isSmall ? "h5" : "h4"}
              >
                Railways Enterprise Management Platform
              </Typography>

              <Typography
                className={classes.heroSubtitle}
                align={isSmall ? "center" : "left"}
                style={{ marginTop: 8 }}
              >
                Unified digital platform for SFTO operations, GPWIS workflows,
                maintenance and railway operational analytics.
              </Typography>

              {/* <Box
                className={classes.heroButtons}
                style={{ display: "flex", justifyContent: isSmall ? "center" : undefined, marginTop: 16 }}
              >
                <Link to="/railways/job/sfto/listjob" className={classes.link}>
                  <Button
                    variant="contained"
                    className={classes.primaryButton}
                    endIcon={<ArrowForwardIcon />}
                    fullWidth={isSmall}
                    style={{ maxWidth: isSmall ? "100%" : 260 }}
                  >
                    Open SFTO Operations
                  </Button>
                </Link>
              </Box> */}
            </Box>
          </Grid>

          {/* TRAIN VISUAL */}
          <Grid item xs={12} md={6}>
            <Box
              className={classes.trainVisual}
              style={{
                display: "flex",
                justifyContent: isSmall ? "center" : "flex-end",
                padding: isSmall ? 12 : 0,
              }}
            >
              <Box
                className={classes.trainBox}
                style={{ maxWidth: isSmall ? 300 : "100%" }}
              >
                <Box className={`${classes.wagon} ${classes.wagon2}`}>
                  <Box className={classes.wheel} style={{ left: 18 }} />
                  <Box className={classes.wheel} style={{ right: 18 }} />
                </Box>

                <Box className={`${classes.wagon} ${classes.wagon1}`}>
                  <Box className={classes.wheel} style={{ left: 18 }} />
                  <Box className={classes.wheel} style={{ right: 18 }} />
                </Box>

                <Box className={classes.engine}>
                  <Box className={classes.engineFront} />
                  <Box className={classes.wheel} style={{ left: 20 }} />
                  <Box className={classes.wheel} style={{ right: 20 }} />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* OPERATIONS */}
      <Box>
        <Box className={classes.sectionHeader}>
          <Box>
            <Typography className={classes.sectionTitle}>
              Railway Operations Control
            </Typography>

            <Typography className={classes.sectionSub}>
              Centralized operational modules
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3} className={classes.fullWidthGrid}>
          {operationModules.map((item) => (
            <Grid item xs={12} md={6} lg={4} key={item.title}>
              <Paper elevation={0} className={classes.operationCard}>
                <Box className={classes.operationTop}>
                  <Box className={classes.operationIcon}>{item.icon}</Box>

                  <TrendingUpIcon
                    style={{
                      color: "#CBD5E1",
                      fontSize: 28,
                    }}
                  />
                </Box>

                <Typography className={classes.operationTitle}>
                  {item.title}
                </Typography>

                <Typography className={classes.operationDesc}>
                  {item.desc}
                </Typography>

                <Box className={classes.operationActions}>
                  {item.type === "single" ? (
                    <Link to={item.path} className={classes.link}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.moduleButton}
                      >
                        Open Module
                      </Button>
                    </Link>
                  ) : (
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.moduleButton}
                      endIcon={<ExpandMoreIcon />}
                      onClick={(e) => openMenu(e, item.menuKey)}
                    >
                      Open Modules
                    </Button>
                  )}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* OVERVIEW */}
      {/* <Box>
        <Box className={classes.sectionHeader}>
          <Box>
            <Typography className={classes.sectionTitle}>
              Enterprise Railway Modules
            </Typography>

            <Typography className={classes.sectionSub}>
              Integrated logistics ecosystem
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3} className={classes.fullWidthGrid}>
          <Grid item xs={12} md={4}>
            <Box className={classes.overviewCard}>
              <Box className={classes.overviewTop}>
                <Box className={classes.overviewIcon}>
                  <AccountTreeIcon
                    style={{
                      color: "#1976D2",
                      fontSize: 28,
                    }}
                  />
                </Box>

                <Typography className={classes.overviewTitle}>
                  Freight Reconciliation
                </Typography>
              </Box>

              <Link
                to="/railways/sfto/reconciliation/main"
                className={classes.link}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.moduleButton}
                >
                  Open Module
                </Button>
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className={classes.overviewCard}>
              <Box className={classes.overviewTop}>
                <Box className={classes.overviewIcon}>
                  <ReceiptIcon
                    style={{
                      color: "#1976D2",
                      fontSize: 28,
                    }}
                  />
                </Box>

                <Typography className={classes.overviewTitle2}>
                  Invoice Management (EPROC)
                </Typography>
              </Box>

              <Link to="/railways/invoice/eproc" className={classes.link}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.moduleButton}
                >
                  Open Module
                </Button>
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className={classes.overviewCard}>
              <Box className={classes.overviewTop}>
                <Box className={classes.overviewIcon}>
                  <BuildIcon
                    style={{
                      color: "#1976D2",
                      fontSize: 28,
                    }}
                  />
                </Box>

                <Typography className={classes.overviewTitle}>
                  MGT Invoiceing
                </Typography>
              </Box>

              <Link to="/railways/mgtinvoice" className={classes.link}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.moduleButton}
                >
                  Open Module
                </Button>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box> */}

      {/* DROPDOWN MENU */}
      <Menu
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={closeMenu}
        classes={{
          paper: classes.menuPaper,
        }}
      >
        {activeMenu.map((subMenu, index) => (
          <Link
            key={index}
            to={subMenu.link}
            className={classes.link}
            onClick={closeMenu}
          >
            <MenuItem className={classes.menuItem}>
              {subMenu.icon && <ListItemIcon>{subMenu.icon}</ListItemIcon>}

              <Typography variant="body2">{subMenu.text}</Typography>
            </MenuItem>
          </Link>
        ))}
      </Menu>

      {/* FOOTER */}
      <Box className={classes.footer}>
        <Typography className={classes.footerText}>
          Railways EMS • Enterprise Freight Operations Platform
        </Typography>

        <Typography className={classes.footerText}>
          Integrated with Azure AD Authentication
        </Typography>
      </Box>
    </Box>
  );
}
